import { CopyButton } from '@jotta/ui/CopyButton'
import { Skeleton } from '@jotta/ui/Skeleton'

type CopyToClipboardCardProps = {
  title: string
  value?: string
}

export const CopyToClipboardCard = ({
  title,
  value,
}: CopyToClipboardCardProps) => {
  if (!value) {
    return <SkeletonCopyToClipboardCard title={title} />
  }

  return (
    <div className="relative rounded-xl bg-surface-container-lowest">
      <div className="flex items-center gap-4 p-4">
        <div className="flex flex-grow flex-col">
          <span className="label-md">{title}</span>
          <span
            className="mt-1 break-all text-body-sm-ln text-outline underline"
            data-testid="CopyToClipboardValue"
          >
            {value}
          </span>
        </div>

        <div>
          <CopyButton value={value} />
        </div>
      </div>
    </div>
  )
}

function SkeletonCopyToClipboardCard({ title }: { title: string }) {
  return (
    <div className="relative rounded-xl bg-surface-container-lowest">
      <div className="flex items-center gap-4 p-4">
        <div className="flex flex-grow flex-col">
          <span className="label-md">{title}</span>
          <Skeleton className="mt-1 w-3/4" />
        </div>
        <Skeleton className="h-8 w-24 rounded-full pt-4" />
      </div>
    </div>
  )
}
